var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 23,
    viewBox: "0 0 33 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H33V22.5H0V0.5Z",
    fill: "#10338C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2936 11.4807C14.3129 11.4614 14.3257 11.4421 14.345 11.4228C14.3322 11.4421 14.3129 11.4614 14.2936 11.4807ZM12.0936 14.176L12.8012 15.6491L14.3901 15.2825L13.6824 16.7491L14.9626 17.7655L13.3672 18.1257L13.3737 19.7597L12.0936 18.7368L10.8199 19.7597L10.8263 18.1257L9.23099 17.7655L10.5111 16.7491L9.79707 15.2825L11.3924 15.6491L12.0936 14.176ZM24.824 16.0094L25.1585 16.7105L25.9175 16.5368L25.5766 17.238L26.1877 17.7205L25.4286 17.8877V18.6725L24.824 18.1836L24.2129 18.6725L24.2193 17.8877L23.4602 17.7205L24.0713 17.238L23.7304 16.5368L24.4895 16.7105L24.824 16.0094ZM21.6977 8.54737L22.0322 9.24854L22.7912 9.07486L22.4503 9.77603L23.0614 10.2585L22.3023 10.4322V11.2105L21.6977 10.7216L21.0865 11.2105L21.093 10.4322L20.3275 10.2585L20.9386 9.77603L20.5977 9.07486L21.3567 9.24854L21.6977 8.54737ZM24.824 4.28889L25.1585 4.99006L25.9175 4.81638L25.5766 5.51755L26.1877 6.00001L25.4286 6.17369V6.95205L24.824 6.46316L24.2129 6.95205L24.2193 6.17369L23.4602 6.00001L24.0713 5.51755L23.7304 4.81638L24.4895 4.99006L24.824 4.28889ZM27.5579 7.48597L27.8924 8.18714L28.6515 8.01346L28.3105 8.71463L28.9216 9.19708L28.1626 9.36433V10.1491L27.5579 9.66024L26.9468 10.1491V9.36433L26.1877 9.19708L26.7988 8.71463L26.4579 8.01346L27.217 8.18714L27.5579 7.48597ZM25.6023 11.2105L25.8661 12.0275H26.7216L26.0269 12.5292L26.2971 13.3462L25.6023 12.838L24.9076 13.3462L25.1713 12.5292L24.483 12.0275H25.3386L25.6023 11.2105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3906 0.5V2.46842L13.4895 4.08304H16.3906V7.89766H12.5889L16.3906 10.0076V11.4807H14.6731L9.94503 8.84971V11.4807H6.36842V8.35439L0.746198 11.4807H-0.0771942V9.51228L2.83041 7.89766H-0.0771942V4.08304H3.72456L-0.0771942 1.96667V0.5H1.64035L6.36842 3.12456V0.5H9.94503V3.62632L15.5737 0.5H16.3906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18596 0.5H7.12748V4.95789H-0.0771942V7.01637H7.12748V11.4807H9.18596V7.01637H16.3906V4.95789H9.18596V0.5Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94502 7.89766L16.3906 11.4807V10.4643L11.7719 7.89766H9.94502Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94502 7.89766L16.3906 11.4807V10.4643L11.7719 7.89766H9.94502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94503 7.89766L16.3906 11.4807V10.4643L11.7719 7.89766H9.94503ZM4.54795 7.89766L-0.0771942 10.4643V11.4807L6.36842 7.89766H4.54795Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.36842 4.08304L-0.0771942 0.5V1.50994L4.54795 4.08304H6.36842Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.36842 4.08304L-0.0771942 0.5V1.50994L4.54795 4.08304H6.36842Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.36842 4.08304L-0.0771942 0.5V1.50994L4.54795 4.08304H6.36842ZM11.7719 4.08304L16.3906 1.50994V0.5L9.94503 4.08304H11.7719Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 22,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAu);
export default __webpack_public_path__ + "static/media/au.9d75d91dd9eda3a848850741ae9fe95d.svg";
export { ForwardRef as ReactComponent };